import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0057FF",
    },
    secondary: {
      main: "#1DB6FF",
    },
    background: {
      default: "#F8FBFF",
    },
  },

  typography: {
    fontFamily: "Inter, sans-serif",

    h1: {
      fontSize: "4rem",
      fontWeight: 700,
    },

    h2: {
      fontSize: "3rem",
      fontWeight: 700,
    },

    body1: {
      color: "#667085",
    },
  },

  shape: {
    borderRadius: 18,
  },
});

export default theme;
